// eslint-disable-next-line @nx/enforce-module-boundaries
import { routeCreator as programManagementRouteCreator } from '@occc-app/routes/ProgramManagement/utils';

const REFERRAL_BASE_URL = `${programManagementRouteCreator.base()}/referral-program`;

export const routeCreator = {
  details: () => REFERRAL_BASE_URL,
  configure: () => `${REFERRAL_BASE_URL}/configure`,
};
